<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EehdDQ/tc-custom/9781473863620.jpg?1712387826660" alt="This image is the cover for the book Aisne 1918, Battleground North West France"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Aisne 1918, Battleground North West France
      </h1>
      <p class="bookDescription body article font2">
        <p>This battlefield guide and history will focus mainly on the events of attack that fell on the British sector of the front between the 27th  1st June 1918, although the offensive which also befell the French forces will not be totally neglected. This area had been a French held sector since 1915 and the French had fought one of its major engagements of the war here in 1917, the ill-fated Nivelle Offensive. French monuments and cemeteries dominate the landscape. The British were also here in 1914, and they too have left reminders of their relative brief presence. However, the actions fought here early in the war tend to be found mainly to the west of the sector. The battlefield of May 1918 scales the heights of the Chemin des Dames ridge, along the Californe Plateau and descends to afforested valley of the Aisne river and canal. The retreat of the Britsh forces during the course of the first day and in following days extends further south almost to the Marne and takes in part of the Champagne region.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Blanchard
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d8f928e0